import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { MsalGuard } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root',
})
export class JoinSectionGuard implements CanActivate {
  private readonly msalGuard = inject(MsalGuard);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (route.queryParamMap.has('key')) {
      // 招待リンク経由で未ログインのユーザーもアクセスさせる
      return true;
    }
    return this.msalGuard.canActivate(route, state);
  }
}
